import { render, staticRenderFns } from "./getAuditingConsulting.vue?vue&type=template&id=85f53788&"
import script from "./getAuditingConsulting.vue?vue&type=script&lang=js&"
export * from "./getAuditingConsulting.vue?vue&type=script&lang=js&"
import style0 from "./getAuditingConsulting.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports